import api from "src/spintr/SpintrApi";

const baseUrl = "/api/v1/users";

export type QueryUsersParams = {
    /**
     * A search term to filter users by name or email. Defaults to "".
     */
    word?: string;

    /**
     * The maximum number of users to return. Defaults to 8.
     */
    take?: number;

    /**
     * The number of users to skip before starting to collect the result set. Defaults to 0.
     */
    skip?: number;

    /**
     * The ID of the unit to filter users by. Optional.
     */
    unitId?: number;

    /**
     * The ID of the role to filter users by. Optional.
     */
    roleId?: number;

    /**
     * The column to order the results by. Defaults to "name".
     */
    orderByColumn?: string;

    /**
     * Whether to sort the results in ascending order. Defaults to true.
     */
    isAscending?: boolean;

    /**
     * Whether to include admin view users. Defaults to false.
     */
    isAdminView?: boolean;

    /**
     * Whether to include deactivated users. Defaults to false.
     */
    includeDeactivated?: boolean;

    /**
     * Whether to include locked users. Defaults to true.
     */
    includeLocked?: boolean;

    /**
     * Whether to include active users. Defaults to true.
     */
    includeActive?: boolean;

    /**
     * Whether to include hidden users. Defaults to false.
     */
    includeHidden?: boolean;

    /**
     * Whether to include language information. Defaults to false.
     */
    includeLanguage?: boolean;

    /**
     * Whether to include only administrators. Defaults to false.
     */
    onlyAdministrators?: boolean;

    /**
     * Whether to include only editors. Defaults to false.
     */
    onlyEditors?: boolean;

    /**
     * Whether to include only external users. Defaults to false.
     */
    onlyExternal?: boolean;
};

export async function queryUsersAsync(
    params?: QueryUsersParams,
    signal?: AbortSignal | undefined
): Promise<Spintr.ISocialUser[]> {
    const response = await api.get<Spintr.ISocialUser[]>(baseUrl, {
        params,
        signal,
    });

    return response.data;
}
